import { Store } from 'vuex'

import { initialiseStores } from '~/utils/store-accessor'

const initializer = function (store: Store<any>) {
  return initialiseStores(store)
}

export const plugins = [initializer]
